import { isMobile } from 'react-device-detect';
import {
  RequestedFeedbackContainer,
  TableHeader,
} from 'src/tabs/styles/Feedback.styled';

export const FeedbackTableHeader = () => {
  return (
    <RequestedFeedbackContainer isHeader>
      <TableHeader>{!isMobile ? 'Requested by' : 'Employee'}</TableHeader>
      {!isMobile && (
        <>
          <TableHeader>Topic</TableHeader>
          <TableHeader>Employee</TableHeader>
        </>
      )}
      <TableHeader>Due Date</TableHeader>
      {!isMobile && <TableHeader>Actions</TableHeader>}
    </RequestedFeedbackContainer>
  );
};
